export default __webpack_public_path__ + "static/media/umbrella-jar.29d0225e.svg";